import { render, staticRenderFns } from "./LogsIndex.vue?vue&type=template&id=10629511"
import script from "./LogsIndex.vue?vue&type=script&lang=js"
export * from "./LogsIndex.vue?vue&type=script&lang=js"
import style0 from "./LogsIndex.vue?vue&type=style&index=0&id=10629511&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports